import { createRef, MutableRefObject } from 'react';
import type { Mesh } from 'three';

// Shared ref to the Sun's solid core mesh for selective occlusion
export const sunCoreRef = createRef<Mesh>() as MutableRefObject<Mesh | null>;
